import controller from './home-controller';
import template from './home.html'

const HomeComponent = {
    bindings: {
        loginErrorMessage: '<'
    },
    controller,
    template,
};

export default HomeComponent;



// WEBPACK FOOTER //
// ./app/components/home/home-component.js